export interface EnvPreset {
  label: string
  apiBaseUrl: string
}

export const ENV_PRESETS: EnvPreset[] = [
  { label: 'Staging', apiBaseUrl: '/proxy-staging' },
  { label: 'Local', apiBaseUrl: '/proxy-local' },
  { label: 'Production', apiBaseUrl: '/proxy-prod' },
]
